import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {ButtonLink} from "@irati/ui/src/Link"
import Hr from "@irati/ui/src/Layout/Hr"
import DownloadSVG from "@irati/ui/images/download_icon.svg"
import {H4} from "@irati/ui/src/Typography/Heading"
import {injectIntl, FormattedMessage, FormattedDate} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import Error from "@irati/ui/src/ErrorText"
import id from "@irati/utils/id"
import LabelValue from "./LabelValue"
import TicketContainer from "./styled/TicketContainer"

const ProductName = styled(H4)`
  display: inline-block;
  padding-left: ${({theme}) => theme.spacing.two};
`

const TicketFile = styled.div`
  position: relative;
  min-height: 50px;
  margin-bottom: 7px;
  display: inline-flex;
`

export class DealSuccessTicketFile extends Component {
  static propTypes = {
    voucher: PropTypes.shape({
      product: PropTypes.object.isRequired,
      code: PropTypes.string.isRequired,
      expiry: PropTypes.string,
      deal: PropTypes.object.isRequired
    }).isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      errorId: null
    }
  }

  getButton = (additionalProps) => {
    const {deal, code} = this.props.voucher

    return (
      <ButtonLink href={code} primary full onClick={() => tracking.redeemPerkFollowLink(deal)} target="_blank" {...additionalProps}>
        <FormattedMessage id="perks.components.tickets.ticket.file.open" />
      </ButtonLink>
    )
  }

  render() {
    const {errorId} = this.state
    const {voucher, formatMessage} = this.props
    const {expiry, product} = voucher

    return (
      <TicketContainer className="ticket" id={id("file", this.props)}>
        <TicketFile id="ticket_file">
          <img alt="file" src={DownloadSVG} />
          <ProductName>{product.name}</ProductName>
        </TicketFile>
        {expiry && (
          <LabelValue
            value={<FormattedDate value={expiry} year="numeric" month="2-digit" day="numeric" />}
            label={formatMessage({id: "perks.components.tickets.ticket.file.expiryDate"})}
          />
        )}
        {errorId && (
          <Error>
            <FormattedMessage id={errorId} />
          </Error>
        )}
        <Hr />
        {this.getButton()}
      </TicketContainer>
    )
  }
}

export default injectIntl(DealSuccessTicketFile)
